import React from 'react';
import { Link } from 'react-router-dom';
import { ALL_JOBS_URL, NEW_GRADUATE_URL } from '../config/careerLinks';
import './Footer.css';

// Contact mailto link for general inquiries
const CONTACT_MAILTO = 'mailto:info@flaretech.tech?' +
  'subject=' + encodeURIComponent('【お問い合わせ】FLARETECHリクルートサイトより') +
  '&body=' + encodeURIComponent(
    'お名前: \n' +
    'フリガナ: \n\n' +
    'メールアドレス: \n' +
    '電話番号: \n\n' +
    'お問い合わせ内容:\n'
  );

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        {/* Header */}
        <div className="footer-header">
          <div className="footer-logo">
            <img src="/common/logo-flaretech.svg" alt="FLARETECH" className="logo-image" />
            <span className="logo-careers">Careers</span>
          </div>
          <div className="footer-buttons">
            <a href={ALL_JOBS_URL} target="_blank" rel="noopener noreferrer" className="footer-entry-btn" aria-label="応募する - 13件募集中">
              <span className="btn-text-main">Entry</span>
              <span className="btn-text-sub">13件</span>
              <svg viewBox="0 0 10 10" fill="currentColor">
                <path d="M5.845 2.22a.75.75 0 0 1 1.06 0L9.23 4.543c.41.41.41 1.075 0 1.485L6.905 8.352a.75.75 0 0 1-1.06-1.061l1.25-1.251H.75a.75.75 0 0 1 0-1.5h6.354l-1.26-1.26a.75.75 0 0 1 0-1.06Z"/>
              </svg>
            </a>
            <a href={NEW_GRADUATE_URL} target="_blank" rel="noopener noreferrer" className="footer-shinsotsu-btn" aria-label="新卒採用 - 3職種募集中">
              <span className="btn-text-main">新卒</span>
              <span className="btn-text-sub">3職種</span>
              <svg viewBox="0 0 10 10" fill="currentColor">
                <path d="M5.845 2.22a.75.75 0 0 1 1.06 0L9.23 4.543c.41.41.41 1.075 0 1.485L6.905 8.352a.75.75 0 0 1-1.06-1.061l1.25-1.251H.75a.75.75 0 0 1 0-1.5h6.354l-1.26-1.26a.75.75 0 0 1 0-1.06Z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Navigation Grid */}
        <nav className="footer-nav" role="navigation" aria-label="フッターナビゲーション">
          {/* About */}
          <div className="footer-column">
            <h4 className="footer-heading">About</h4>
            <ul className="footer-links">
              <li><Link to="/about/summary">1ページで考えるフレアテック</Link></li>
              <li><Link to="/about/business">フレアテックの事業</Link></li>
              <li><Link to="/about/prerequisites">入社前に知ってほしい前提</Link></li>
              <li><Link to="/about/ai">AIと働くフレアテックの現在地</Link></li>
              <li><Link to="/about/story">フレアテックの物語</Link></li>
              <li><Link to="/about/future">私たちの進む方向</Link></li>
              <li><Link to="/about/experience-shift">企業の体験価値シフトの歴史</Link></li>
              <li><Link to="/about/leadership">フレアテックの経営陣</Link></li>
              <li><Link to="/about/more">フレアテックをもっと知るリンク集</Link></li>
            </ul>
          </div>

          {/* Culture */}
          <div className="footer-column">
            <h4 className="footer-heading">Culture</h4>
            <ul className="footer-links">
              <li><Link to="/culture/vision-mission">ビジョンとミッション</Link></li>
              <li><Link to="/culture/values">フレアテックのバリュー（価値観）</Link></li>
              <li><Link to="/culture/keywords">フレアテックの社内用語</Link></li>
              <li><Link to="/culture/knowledge">フレアテックのナレッジ</Link></li>
            </ul>
          </div>

          {/* Job */}
          <div className="footer-column">
            <h4 className="footer-heading">Job</h4>
            <ul className="footer-links">
              <li><Link to="/jobs/ui-ux-designer">UI/UXデザイナー</Link></li>
              <li><Link to="/jobs/service-designer">サービスデザイナー</Link></li>
              <li><Link to="/jobs/sales">セールス（営業）</Link></li>
              <li><Link to="/jobs/pdm">プロダクトマネージャー（PdM）</Link></li>
              <li><Link to="/jobs/pm">プロジェクトマネージャー（PM）</Link></li>
              <li><Link to="/jobs/engineer">エンジニア</Link></li>
            </ul>
          </div>

          {/* People */}
          <div className="footer-column">
            <h4 className="footer-heading">People</h4>
            <ul className="footer-links">
              <li><Link to="/people">社員インタビュー</Link></li>
              <li><Link to="/people">座談会</Link></li>
            </ul>
          </div>

          {/* Interview */}
          <div className="footer-column">
            <h4 className="footer-heading">Interview</h4>
            <ul className="footer-links">
              <li><Link to="/interview">インタビュー一覧</Link></li>
              <li><Link to="/interview?job=engineer">エンジニア</Link></li>
              <li><Link to="/interview?job=infra">インフラエンジニア</Link></li>
              <li><Link to="/interview?job=dx">DXエンジニア</Link></li>
              <li><Link to="/interview?job=sales">営業</Link></li>
            </ul>
          </div>

          {/* Workstyle */}
          <div className="footer-column">
            <h4 className="footer-heading">Workstyle</h4>
            <ul className="footer-links">
              <li><Link to="/workstyle/survey">社員アンケート</Link></li>
              <li><Link to="/workstyle/px">フレアテックのPeople Experience</Link></li>
              <li><Link to="/workstyle/onboarding">オンボーディング</Link></li>
              <li><Link to="/workstyle/development">育成・学習機会</Link></li>
              <li><Link to="/workstyle/evaluation">評価と報酬</Link></li>
              <li><Link to="/workstyle/career-path">キャリアパス</Link></li>
              <li><Link to="/workstyle/benefits">福利厚生</Link></li>
            </ul>
          </div>

          {/* Process */}
          <div className="footer-column">
            <h4 className="footer-heading">Process</h4>
            <ul className="footer-links">
              <li><Link to="/process/process">選考プロセス</Link></li>
              <li><Link to="/process/reentry">リエントリー制度</Link></li>
              <li><Link to="/process/alumni">アルムナイ採用</Link></li>
              <li><Link to="/process/faq">よくある質問</Link></li>
            </ul>
          </div>
        </nav>

        {/* Bottom */}
        <div className="footer-bottom">
          <div className="footer-social">
            {/* X */}
            <a href="https://twitter.com/FLARETECH_saiyo" className="social-icon" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            {/* YouTube */}
            <a href="https://www.youtube.com/channel/UCbLZK0VW8Kf0PtzuoPn5vXg" className="social-icon youtube" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            {/* note */}
            <a href="https://note.com/flaretech_it" className="social-icon note" target="_blank" rel="noopener noreferrer" aria-label="note">
              <span className="note-text">no<span className="note-plus">+</span>e</span>
            </a>
            {/* FLARETECH Blog - Temporarily disabled */}
            {/* <a href="#" className="social-icon blog" target="_blank" rel="noopener noreferrer">
              <img src="/common/logo-flaretech.svg" alt="FLARETECH" className="blog-logo" />
              <span className="blog-text">Blog</span>
            </a> */}
          </div>

          <div className="footer-legal">
            <a href={CONTACT_MAILTO} className="footer-legal-link">Contact</a>
            <a href="https://flaretech.co.jp/jp/" target="_blank" rel="noopener noreferrer" className="footer-legal-link">Corporate Site</a>
            <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
            <Link to="/security-policy" className="footer-legal-link">Security Policy</Link>
          </div>

          {/* Best Venture 100 Disclaimer */}
          <div className="footer-disclaimer">
            <p>「ベストベンチャー100」は、イシン(株)が提供する法人向け有料会員制サービスです。エントリーした企業の中から、厳正な審査のもと選出したベンチャー企業100社が「ベストベンチャー100」として紹介されます。</p>
          </div>
        </div>

          <div className="footer-copyright">
          © FLARETECH Inc. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
